export default __webpack_public_path__ + "static/media/contact-1_2dc.e5e8ccd9.jpg";